import { createReducer, on } from '@ngrx/store';
import { Action } from '../../models';
import {
  resetStateAction,
  setStateAction,
} from '../actions/demand-notice-invoice.actions';

export interface DemandNoticeInvoiceReducerStateInterface {
  data: any;
}

export const initialState: DemandNoticeInvoiceReducerStateInterface = {
  data: null,
};

const reducer = createReducer(
  initialState,
  on(setStateAction, (state, payload) => {
    return {
      ...state,
      ...payload,
    };
  }),
  on(resetStateAction, () => {
    return initialState;
  })
);

export function demandNoticeInvoiceReducer(
  state: DemandNoticeInvoiceReducerStateInterface,
  action: Action
) {
  return reducer(state, action);
}
